<template>
    <button class="button navigation" type="button">
        <span class="icon arrow-back" />
        <span class="hide-android">
            <slot>{{ $t('1b311bbf-8cc3-4b91-a019-f80a062d8d4d') }}</slot>
        </span>
    </button>
</template>
